/// <reference types="yandex-metrika-tag"/>

const metrikaId = __appConfig.metrika.counter;

const GOALS = {
    createSkill: 'dev-console.create_dialog',
    verstehenLaunch: 'dev-console.verstehen-launch',
} as const;

export const reachGoal = (goalId: keyof typeof GOALS) => {
    try {
        ym(Number(metrikaId), 'reachGoal', GOALS[goalId]);
    } catch (ex) {
        console.error(ex);
    }
};
